<template>
  <div
    v-on-clickaway="close"
    class="personal-counter-tooltip"
  >
    <slot />
    <EButton
      class="personal-counter-tooltip__close"
      icon="close"
      icon-size="s"
      size="s"
      variant="bare"
      data-test-id="personal-counter-tooltip-close"
      @click="close"
    />
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import EButton from '~~/common/vue/components/button';

export default {
  name: 'EPersonalCounterTooltip',
  components: {
    EButton,
  },
  mixins: [
    clickaway,
  ],
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
$arrow-size: 20px;

.personal-counter-tooltip {
  border-radius: $border-radius-m;
  display: flex;
  font-size: $font-l;
  padding: $space-s;
  z-index: $z-index-1l;
  width: 340px;
}

.personal-counter-tooltip::before {
  border-radius: $border-radius-1s;
  content: '';
  height: $arrow-size;
  width: $arrow-size;
  transform: rotate(45deg);
  z-index: $z-index-s;
  position: absolute;
  top: - $space-2s;
  left: $space-s;

  @include desktop {
    left: unset;
    right: $space-s;
  }
}

.personal-counter-tooltip,
.personal-counter-tooltip::before {
  background-color: var(--color-brand-secondary);
}

.personal-counter-tooltip__close {
  transform: translate($space-2s, -$space-2s);
}

.personal-counter-tooltip,
.personal-counter-tooltip__close {
  color: var(--color-button-content-primary);
}
</style>
